// extracted by mini-css-extract-plugin
module.exports = {"detailnav":"DetailNav-module__detailnav___ovFeo"};